// modules/calendar/models/ExternAppointmentScheduleDTO.ts
import { ExternAppointmentSchedule } from './ExternAppointmentSchedule'

export interface ExternAppointmentScheduleDTO {
  id?: string
  from: string
  to: string
  userId: string
  createdAt?: Date
  isActive?: boolean
  days: string
}

export function emptyExternAppointmentScheduleDTO(
  userId: string = ''
): ExternAppointmentScheduleDTO {
  return {
    from: '',
    to: '',
    userId: userId,
    isActive: true,
    days: '',
  }
}

export function fromModel(model: ExternAppointmentSchedule): ExternAppointmentScheduleDTO {
  return {
    id: model.id,
    from: model.from,
    to: model.to,
    userId: model.userId,
    createdAt: model.createdAt,
    isActive: model.isActive,
    days: model.days,
  }
}

export function toModel(dto: ExternAppointmentScheduleDTO): ExternAppointmentSchedule {
  return new ExternAppointmentSchedule({
    id: dto.id,
    userId: dto.userId,
    from: dto.from,
    to: dto.to,
    createdAt: dto.createdAt,
    isActive: dto.isActive,
    days: dto.days,
  })
}
